module.exports = __webpack_public_path__ + "static/media/report3.be4fc446.png";